module.exports = __webpack_public_path__ + "static/media/android.491686d6.png";